import script from "./process-tenant-payments-modal.vue?vue&type=script&setup=true&lang=ts"
export * from "./process-tenant-payments-modal.vue?vue&type=script&setup=true&lang=ts"

import "./process-tenant-payments-modal.vue?vue&type=style&index=0&id=6f1e6dfc&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6f1e6dfc"]])

export default __exports__